import packages from '../../package.json';



export const environment = {
  version: packages.version,
  production: '${IS_PROD}',
  API_URL: '${API_URL}',
  CORE_URL: '${CORE_URL}',
  WS_URL: '${WS_URL}',
};
